import { useCallback } from 'react';
import { getActiveWords } from './utils';
import { Word } from '@/player-config/src/types/transcript-types';
import { remotionPlayerStateStore } from '@/Pages/Clip/ClipPlayer/ClipNewTimeline/store/remotionPlayerState';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import classes from './Transcript.module.scss';

export default function useFullClipTranscriptHighlight({
  transcript,
  container,
  activeHighlightedPause
}: {
  transcript: Record<string, Word[]>;
  container: React.RefObject<HTMLDivElement>;
  activeHighlightedPause: { segmentId: string; startTime: number } | null;
}) {
  const { clipData } = useClipsContext();

  const highlightFullClipActiveWord = useCallback(() => {
    if (!container.current) {
      return;
    }
    const currentTime = remotionPlayerStateStore.getSnapshot().currentTime;
    container.current!.querySelector(`.${classes['active-word']}`)?.classList.remove(classes['active-word']);

    if (activeHighlightedPause) {
      return;
    }

    const { activeWords, currentSegment } = getActiveWords({ currentTime, transcript, clipData });
    if (activeWords.length === 0 || !currentSegment) {
      return;
    }
    (activeWords || []).forEach(word => {
      const wordElement = container.current!.querySelector(
        `[data-word-id="${word.index}"][data-segment-id="${currentSegment.id}"]`
      ) as HTMLDivElement;
      if (wordElement) {
        wordElement.classList.add(classes['active-word']);
      }
    });
  }, [container, transcript, clipData, activeHighlightedPause]);

  return { highlightFullClipActiveWord };
}
